import React, { useState } from 'react';

//@ts-ignore
import '../../styles/appinfooverview.scss';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import RatingDistributionComponent from '../Dashboard/RatingDistributionComponent';
import StarRatingComponent from '../StarRatingComponent';

import { Card, Stack, Typography } from '@mui/joy';
import { useAuth } from '../../context/authContext';
import { cardStyles } from '../../styles/cardStyles';
import InfoTooltipComponent from '../InfoTooltipComponent';

const networking = require('../../Networking/API');

function AppInfoOverviewComponent(app: any) {
    const { token } = useAuth();

    var average = 0;
    var reviewsByRating = [];
    var replyRate = 0;

    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState(null) as any[];

    if (!reviews) {
        getData();
    }

    function getData() {
        networking.reviewsFor(app.app.id, token).then((reviews: any) => {
            setReviews(reviews.filter((d: any) => d.store_id !== ''));
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    if (reviews) {
        const ratingSet = [1, 2, 3, 4, 5] as number[];
        var ratings = [] as number[]

        reviews.filter((d: any) => parseInt(d.rating) !== 0).forEach((review: any) => {
            ratings.push(parseInt(review.rating));
        });

        const total = ratings.reduce((a, v) => a + v, 0);
        average = (total / ratings.length);

        reviewsByRating = ratingSet.map((r: number) =>
            reviews.filter((d: any) => parseInt(d.rating) === r)
        );

        const repliedReviews = reviews.filter((d: any) => d.reply && d.reply.length > 0);
        replyRate = (repliedReviews.length / reviews.length) * 100;
    }

    return (
        <Card
            variant='outlined'
            sx={{
                ...cardStyles.base
            }}>
            {loading ?
                <LoadingSpinnerComponent />
                :
                <div>
                    <div className='row'>
                        <div className='col-md my-auto'>
                            <div className='text-center'>
                                <Typography
                                    color='neutral'
                                    fontWeight={600}
                                    level='body-xs'>
                                    {"Total Reviews".toUpperCase()}
                                    <InfoTooltipComponent
                                        message={"Total number of reviews received for this app."}
                                        size={'sm'}
                                        variant={'plain'}
                                        color={'primary'} />
                                </Typography>
                                <Typography
                                    color='primary'
                                    fontWeight={300}
                                    sx={{
                                        fontSize: 52
                                    }}>
                                    {reviews && reviews.length}
                                </Typography>
                            </div>
                        </div>
                        <div className='col-md-auto my-auto'>
                            <div className='text-center'>
                                <Typography
                                    color='neutral'
                                    fontWeight={600}
                                    level='body-xs'>
                                    {"Reply Rate".toUpperCase()}
                                    <InfoTooltipComponent
                                        message={"Percentage of reviews that have received a reply from the developer."}
                                        size={'sm'}
                                        variant={'plain'}
                                        color={'primary'} />
                                </Typography>
                                <Typography
                                    color='primary'
                                    fontWeight={300}
                                    sx={{
                                        fontSize: 42
                                    }}>
                                    {reviews && reviews.length > 0 ? replyRate.toFixed(0) : 0}%
                                </Typography>
                                <Typography
                                    color='neutral'
                                    fontWeight={500}
                                    level='body-xs'
                                    width={200}>
                                    {app.app.appstore_connect ? "" : "* Enable App Store Connect integration to track developer replies also on App Store."}
                                </Typography>
                            </div>
                        </div>
                        <div className='col-md my-auto'>
                            <Stack
                                spacing={1}
                                sx={{
                                    textAlign: 'center'
                                }}>
                                <Typography
                                    color='neutral'
                                    fontWeight={600}
                                    level='body-xs'>
                                    {"Average rating".toUpperCase()}
                                    <InfoTooltipComponent
                                        message={"Average rating of the app based on users' written reviews."}
                                        size={'sm'}
                                        variant={'plain'}
                                        color={'primary'} />
                                </Typography>
                                {average && <StarRatingComponent rating={average} />}
                                <Typography
                                    color='neutral'
                                    fontWeight={600}
                                    level='body-xs'>
                                    {average.toFixed(2)}
                                    <span>
                                        <Typography
                                            color='neutral'
                                            level='body-xs'>
                                            {" Stars"}
                                        </Typography>
                                    </span>
                                </Typography>
                            </Stack>
                        </div>
                        <div className='col-md mx-auto p-3'>
                            <Typography
                                color='neutral'
                                fontWeight={600}
                                level='body-xs'
                                sx={{
                                    textAlign: 'center',
                                    marginBottom: 2
                                }}>
                                {"Stars breakdown".toUpperCase()}
                                <InfoTooltipComponent
                                    message={"Distribution of ratings of the app based on users' written reviews."}
                                    size={'sm'}
                                    variant={'plain'}
                                    color={'primary'} />
                            </Typography>
                            <RatingDistributionComponent
                                reviews={reviewsByRating}
                                total={reviews && reviews.length} />
                        </div>
                    </div>
                </div >
            }
        </Card >
    )
}

export default AppInfoOverviewComponent;